(function () {
  var breakpoint = 900;
  var activeClass = 'ts-desktop-presentation-active';
  var shell = document.querySelector('[data-desktop-phone-presentation]');
  var screen = document.querySelector('[data-desktop-phone-screen]');
  var viewport = document.querySelector('[data-desktop-phone-viewport]');
  var movedElements = [];
  var movedConceptBackground = null;
  var isActive = false;
  var lastTouchY = null;
  var deviceWidth = 430;
  var deviceHeight = deviceWidth * 590 / 280;
  var canvasPadding = 68;

  if (!shell || !screen || !viewport) {
    return;
  }

  var mediaQuery = window.matchMedia('(min-width: ' + breakpoint + 'px)');

  function isEditorMode() {
    var pageContainer = document.getElementById('PageContainer');
    var pageContainerEditorOpen = pageContainer && pageContainer.dataset.editorOpen === 'true';
    var shopifyEditorOpen = window.Shopify && (window.Shopify.designMode || window.Shopify.visualPreviewMode);

    return pageContainerEditorOpen || shopifyEditorOpen;
  }

  function shouldActivate() {
    return mediaQuery.matches && !isEditorMode();
  }

  function shouldMoveElement(element) {
    var tagName = element.tagName;

    if (element === shell || tagName === 'SCRIPT' || tagName === 'STYLE') {
      return false;
    }

    if (element.hasAttribute('data-ts-contact-modal')) {
      return false;
    }

    if (
      element.id === 'DrawerOverlay' ||
      element.id === 'ThemeModal' ||
      element.id === 'QuizOverlay' ||
      element.id === 'QuizModal'
    ) {
      return false;
    }

    return true;
  }

  function movePageIntoPhone() {
    if (movedElements.length > 0) {
      return;
    }

    Array.prototype.slice.call(document.body.children).forEach(function (element) {
      if (!shouldMoveElement(element)) {
        return;
      }

      var placeholder = document.createComment('desktop-phone-presentation-placeholder');
      element.parentNode.insertBefore(placeholder, element);
      viewport.appendChild(element);
      movedElements.push({
        element: element,
        placeholder: placeholder
      });
    });
  }

  function moveConceptBackgroundIntoScreen() {
    if (movedConceptBackground) {
      return;
    }

    var background = viewport.querySelector('.ts-concept-mobile-bg');
    if (!background) {
      return;
    }

    var layer = screen.querySelector('[data-desktop-phone-background-layer]');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'desktop-phone-presentation__background-layer';
      layer.setAttribute('data-desktop-phone-background-layer', '');
      layer.setAttribute('aria-hidden', 'true');
      screen.insertBefore(layer, viewport);
    }

    var placeholder = document.createComment('desktop-phone-concept-background-placeholder');
    background.parentNode.insertBefore(placeholder, background);
    layer.appendChild(background);
    movedConceptBackground = {
      element: background,
      placeholder: placeholder,
      layer: layer
    };
  }

  function syncScale() {
    var availableWidth = Math.max(window.innerWidth - canvasPadding, 1);
    var availableHeight = Math.max(window.innerHeight - canvasPadding, 1);
    var scale = Math.min(availableWidth / deviceWidth, availableHeight / deviceHeight, 1);

    shell.style.setProperty('--desktop-phone-scale', scale.toFixed(4));
  }

  function restorePageFromPhone() {
    if (movedConceptBackground) {
      movedConceptBackground.placeholder.parentNode.insertBefore(movedConceptBackground.element, movedConceptBackground.placeholder);
      movedConceptBackground.placeholder.parentNode.removeChild(movedConceptBackground.placeholder);
      if (movedConceptBackground.layer.parentNode) {
        movedConceptBackground.layer.parentNode.removeChild(movedConceptBackground.layer);
      }
      movedConceptBackground = null;
    }

    movedElements.forEach(function (item) {
      item.placeholder.parentNode.insertBefore(item.element, item.placeholder);
      item.placeholder.parentNode.removeChild(item.placeholder);
    });
    movedElements = [];
  }

  function setDesktopHeroShine(active) {
    var shine = viewport.querySelector('.ts-concept-hero__shine');
    if (!shine) {
      return;
    }

    if (active) {
      shine.dispatchEvent(new CustomEvent('tori:hero-shine:trigger', {
        bubbles: true
      }));
      return;
    }

    shine.dispatchEvent(new CustomEvent('tori:hero-shine:reset', {
      bubbles: true
    }));
    shine.classList.remove('is-shine-entering', 'is-shine-running', 'is-shine-exiting');
  }

  function activate() {
    if (isActive) {
      return;
    }

    movePageIntoPhone();
    moveConceptBackgroundIntoScreen();
    syncScale();
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    viewport.setAttribute('tabindex', '0');
    document.documentElement.classList.add(activeClass);
    document.body.classList.add(activeClass);
    window.scrollTo(0, 0);
    isActive = true;
    setDesktopHeroShine(true);
    document.dispatchEvent(new CustomEvent('tori:desktop-presentation:activate', {
      detail: {
        root: viewport
      }
    }));
  }

  function deactivate() {
    if (!isActive) {
      return;
    }

    document.documentElement.classList.remove(activeClass);
    document.body.classList.remove(activeClass);
    shell.hidden = true;
    shell.setAttribute('aria-hidden', 'true');
    viewport.removeAttribute('tabindex');
    setDesktopHeroShine(false);
    restorePageFromPhone();
    shell.style.removeProperty('--desktop-phone-scale');
    isActive = false;
  }

  function syncPresentation() {
    if (shouldActivate()) {
      activate();
    } else {
      deactivate();
    }
  }

  viewport.addEventListener('scroll', function () {
    if (viewport.scrollLeft !== 0) {
      viewport.scrollLeft = 0;
    }
    window.dispatchEvent(new Event('scroll'));
  });

  shell.addEventListener('wheel', function (event) {
    if (!isActive) {
      return;
    }

    event.preventDefault();
    viewport.scrollTop += event.deltaY;
    if (viewport.scrollLeft !== 0) {
      viewport.scrollLeft = 0;
    }
  }, { passive: false });

  shell.addEventListener('touchstart', function (event) {
    if (!isActive || event.touches.length !== 1) {
      return;
    }

    lastTouchY = event.touches[0].clientY;
  }, { passive: true });

  shell.addEventListener('touchmove', function (event) {
    if (!isActive || event.touches.length !== 1 || lastTouchY === null) {
      return;
    }

    var nextTouchY = event.touches[0].clientY;
    viewport.scrollTop += lastTouchY - nextTouchY;
    lastTouchY = nextTouchY;
    event.preventDefault();
  }, { passive: false });

  shell.addEventListener('touchend', function () {
    lastTouchY = null;
  });

  window.addEventListener('resize', function () {
    if (isActive) {
      syncScale();
    }
  });

  syncPresentation();
  mediaQuery.addEventListener('change', syncPresentation);
})();
